import React, { useContext } from 'react';
import { Utility } from './utils';
import { returnMonths } from '../../../utils/consts/months';
import { LocaleSettingContext } from '../../../utils/consts/localeSetting';

function MonthSection({ monthIndex, onChange: onClick, isDarkMode = false }) {
  const localState = JSON.parse(localStorage.getItem('state'));
  const { direction, timeZone } = useContext(LocaleSettingContext),
    { month: currMonth } = Utility.currentDate(
      monthIndex,
      direction,
      timeZone,
      localState?.language?.name,
    ),
    monthList = returnMonths(direction);
  return (
    <div className="col p-0 align-items-center pb-2">
      <div className={'col p-2'}>
        <ul
          className={`${
            isDarkMode ? 'datepicker-month-view-dark' : 'datepicker-month-view'
          } d-flex flex-wrap`}
        >
          <MonthSection.Months monthList={monthList}>
            {(month) => (
              <MonthSection.Month {...{ month, currMonth, onClick }} />
            )}
          </MonthSection.Months>
        </ul>
      </div>
    </div>
  );
}

MonthSection.createCustomProto({
  Months: function ({ monthList, children }) {
    return monthList.map((month) => (
      <li
        key={month.Name}
        className="month p-1 font-small text-center p-1 font-weight-bold cursor-pointer"
      >
        {children(month)}
      </li>
    ));
  },
  Month: function ({ month, currMonth, onClick }) {
    const className = month.index == currMonth ? ' selected' : '';
    return (
      <div
        className={`border d-flex align-items-center justify-content-center text-muted${className}`}
        style={{ height: '100%', width: '80%' }}
        onClick={onClick.bind(null, month, currMonth)}
      >
        {month.Name}
      </div>
    );
  },
});

export { MonthSection };
